import { styled } from "@mui/material";
import Box from "@mui/material/Box";

export const StyledContainer = styled(Box, {
  shouldForwardProp: (prop: string) =>
    prop !== "$largerGap" && prop !== "$checkboxGap",
})<{
  $largerGap?: boolean;
  $checkboxGap?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  gap: ${({ $largerGap, theme }) =>
    $largerGap ? theme.wsc.spacing[2] : theme.wsc.spacing[1]};
  ${({ $checkboxGap, theme }) =>
    $checkboxGap && `padding-left: ${theme.wsc.spacing[1]}`};
`;
